const { load } = require('cheerio');
const { productVideoInit } = require('./productVideo');

window.jQuery = window.$ = require('jquery');

const slickCarouselInit = () => {

    $.getScript( "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js" )
    .done(function( script, textStatus ) {
        /* initialize slider */ 
        $(".products-slider .slide-inner, .flexible-slider .slide-inner").not('.slick-initialized').slick();

        if ($('.experience-headerbanner .campaign-banner').length > 1) {
            $('.experience-headerbanner .campaign-banner-wrapper').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                dots: false,
                infinite: true,
                draggable: true,
                autoplay: true,
                speed: 500
            });
        }
       
        if( $(".carousel-item-list").length ) {
            $(".carousel-item-list").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                dots: true,
                infinite: false,
                useTransform: false,
                adaptiveHeight: true,
                asNavFor: ".carousel-thumbnail--list",
                prevArrow: '<i class="fa fa-chevron-left carousel-prev"></i>',
                nextArrow: '<i class="fa fa-chevron-right carousel-next"></i>'
            });
        }

        /* initialize slider thumbnail */ 
        if( $(".carousel-thumbnail--list").length ) {
            $(".carousel-thumbnail--list").slick({
                slidesToShow: 5,
                arrows: true,
                slidesToScroll: 1,
                asNavFor: ".carousel-item-list",
                focusOnSelect: true,
                infinite: false,
                vertical: true,
                verticalSwiping: true,
                prevArrow: '<i class="fa fa-chevron-up slick-prev"></i>',
                nextArrow: '<i class="fa fa-chevron-down slick-next"></i>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                ]
            });
            
            $('.carousel-item-list .carousel-item.video-item').each(function () {
                var _this = $(this);
                setTimeout(function() {
                    var index = _this.data('slick-index');
                    $(".slick-dots li").eq(index).addClass('video-item');
                }, 100);
            });
      
        }

        setTimeout(function() {
            $(".recently-view-products, .best-seller-products").closest('.fullpage-gradient').removeClass('d-none');
            $('.product-view-similar').show();
            $('.recently-view-products .product-grid, .best-seller-products .product-grid').not('.slick-initialized').slick({
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                infinite: true,
                dots: false,
                draggable:true,
                prevArrow: '<i class="fa fa-chevron-left slick-prev"></i>',
                nextArrow: '<i class="fa fa-chevron-right slick-next"></i>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4
                        },
                    },
                    {
                        breakpoint: 542,
                        settings: {
                            slidesToScroll: 2,
                            slidesToShow: 2
                        },
                    }
                ]
            });
        }, 1000);
    })
    .fail(function( jqxhr, settings, exception ) {
        console.log('slick initialization has been failed.')    
    });
}


const slickModalCarouselInit = () => {
    var thumbnail = $('.product-quickview .carousel-thumbnail--list');
    var item = $('.product-quickview .carousel-item-list');

    if(thumbnail.length){
        thumbnail.not('.slick-initialized').slick({
            slidesToShow: 4,
            arrows: true,
            slidesToScroll: 1,
            asNavFor: ".carousel-item-list",
            focusOnSelect: true,
            infinite: false,
            vertical: true,
            verticalSwiping: true,
            prevArrow: '<i class="fa fa-chevron-up slick-prev"></i>',
            nextArrow: '<i class="fa fa-chevron-down slick-next"></i>',
            
        });
    }

    if(item.length){
        item.not('.slick-initialized').slick({
            swipe: true,
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            asNavFor: ".carousel-thumbnail--list",
            prevArrow: '<i class="fa fa-chevron-left carousel-prev"></i>',
            nextArrow: '<i class="fa fa-chevron-right carousel-next"></i>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        slidesToShow: 2.5
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        slidesToShow: 2.5
                    }
                }
            ]
        });
    }

    /* prevent video to overflow  from carousel */
    $('.product-quickview .carousel-item-list .carousel-item:first-child').outerHeight();
    $('.product-quickview .carousel-item-list .carousel-item.video-item').css({
        'height' : $('.product-quickview .carousel-item-list .carousel-item:first-child').outerHeight(),
        'overflow': 'hidden',
    });
    productVideoInit();
}

$(document).ready(function () {
    slickCarouselInit();
    slickModalCarouselInit();
});

module.exports = {
    slickModalCarouselInit,
};